
import { LabelLayoutModel } from "@/models/label-layout/label-layout-model";
import { LabelLayoutService } from "@/services";
import { HumanFilter } from "@/utils/human-filter";
import Vue from "vue";
import { BrowseStateBase } from "../../utils/browse/browse-state-base";
import { BrowserInfo } from "@/utils/browser";
import { runJsTemplate } from "@/utils/js-template";
import {printHumanFloat,printShortDate} from "@/utils/pretty-print";
import {ZplPrint} from "@/utils/electron/electron-print-zpl";
import AppEpsonLabelModal from "./EpsonLabelModal.vue";

export default Vue.extend({
	data(){
		return {
			isPrinting: false,
			copies: 1,
			epsonLayout: null as LabelLayoutModel | null,
			epsonRecords: [] as any[]
		};
	},
	props: {
		state: {
			type: Object as ()=>BrowseStateBase,
			required: true
		}
	},
	computed: {
		layouts():LabelLayoutModel[] {
			return this.state.labelLayouts;
		},
		isElectron():boolean {
			return BrowserInfo.hasElectronConfigured();
		}
	},
	methods: {
		close(){
			this.state.printLabelsModalOpen = false;
		},
		// eslint-disable-next-line max-lines-per-function
		async printWithLayout(layout:LabelLayoutModel){
			if (this.state.selectedItems.length == 0) return this.close();
			if (this.isPrinting) return;
			this.isPrinting = true;
			try{
				layout = await LabelLayoutService.getById(layout.ID);
				if (!layout.Data) return;
				let filter = new HumanFilter();
				filter.Field = `this.ID`;
				filter.Operator = "in";
				filter.Values = this.state.selectedItems.map(i=>`${i.ID}`);
				let records = await this.state.dataSource.getElements({
					filters: [
						filter
					],
					limit: 500,
					offset: 0,
					orderBy: "ID",
					orderDirection: "ASC",
					view: this.state.querySettings.view,
					dontSaveViewSettings: true,
					additionalPreloads: layout.Data.Data.Preloads
				});

				if (layout.Data.Data.Epson.Enabled) {
					// Epson ColorWorks: het Vercel-iframe toont de preview en levert de ESC/Label-jobs.
					this.epsonRecords = records.data;
					this.epsonLayout = layout;
					this.isPrinting = false;
					return;
				}

				if(layout.Data.Data.Zpl){
					let zPl = "";
					for (const record of records.data) {
						for (let i = 0; i < this.copies; i++) {
							zPl = zPl + runJsTemplate(layout.Data.Data.Zpl, record, {printHumanFloat,printShortDate}).replace(/[\r\n]+/g, "") + "\n";
						}
					}
					await ZplPrint.print(zPl,layout);
					this.close();
					return;
				}
				layout.Data.Data.print(records.data, layout, this.copies);
				this.close();
			}catch(err){

			}
			this.isPrinting = false;
		}
	},
	components: {
		AppEpsonLabelModal
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
